import { render } from "./ModalCarousel.vue?vue&type=template&id=aeb2733e"
import script from "./ModalCarousel.vue?vue&type=script&lang=js"
export * from "./ModalCarousel.vue?vue&type=script&lang=js"

import "./ModalCarousel.vue?vue&type=style&index=0&id=aeb2733e&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__